var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11002",
    "data-name": "Grupo 11002",
    transform: "translate(-723.566 -1630.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11001",
    "data-name": "Grupo 11001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13844",
    "data-name": "Caminho 13844",
    d: "M739.086,1635.131l-8.849,8.849-1.671,5.151,5.151-1.67,8.849-8.849Zm2.32,3.481-1.16,1.16-2.32-2.321,1.16-1.16Zm-10.626,6.352,1.953,1.953-.876.285-1.361-1.362Zm.4-.763,6.169-6.169.87.87-6.169,6.169Zm1.45,1.45,6.169-6.169.87.87-6.169,6.169Zm-2.415,1.065.769.77-1.138.369Z",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.be67f816caad8fd30c048a671ba378fc.svg";
export { ForwardRef as ReactComponent };